//瑞典
export default {
    common: {
        notshow: 'Visa inte idag',
        unit: 'USDT',
        day: 'Dag',
        week: 'Vecka',
        save: 'Spara',
        submit: 'Skicka',
        confirmtitle: 'Bekräfta åtgärd',
        confirm: 'Bekräfta',
        reset: 'Återställ',
        refresh: 'Uppdatera',
        copy: 'Kopiera',
        copysuccessful: 'Kopiering lyckades',
        modify: 'Ändra',
        binding: 'Bind',
        finished: 'Slutförd',
        canceled: 'Avbruten',
        cancel: 'Avbryt',
        all: 'Alla',
        back: 'Tillbaka',
        loading: 'Laddar...',
        nomore: 'Alla poster',
        errortxt: 'Laddning misslyckades',
        loosing: 'Släpp för att uppdatera...',
        pulling: 'Dra ner för att uppdatera...',
        nodata: 'Inga poster än',
        buy: 'Köp',
        buyup: 'Köp Upp',
        buydown: 'Köp Ner',
        sell: 'Sälj',
        forserver: 'Kontakta kundtjänst',
        total: 'Totalt',
        status1: 'Väntar på granskning',
        status2: 'Slutförd',
        status3: 'Avvisad',
        paytype1: 'TRC20',
        paytype2: 'ERC20',
        paytype3: 'Banköverföring'
    },
    footer: {
        home: 'Hem',
        market: 'Marknad',
        exchange: 'Börs',
        options: 'Optioner',
        assets: 'Tillgångar',
        change: 'Överföring',
        recharge: 'Insättning',
        withdrawal: 'Uttag'
    },
    home: {
        menu1: 'Optionshandel',
        menu1desc: 'Stöder BTC/USDT etc',
        menu2: 'Snabb insättning',
        menu3: 'Uttag',
        menu4: 'Online support',
        menu5: 'Snabbväxling',
        menu6: 'Lån',
        menu7: 'Staking Mining',
        menu8: 'Pant',
        menu9: 'Kontoöverföring',
        ranktitle: 'Stigande lista',
        name: 'Namn',
        price: 'Senaste pris',
        risefall: 'Förändring %'
    },
    register: {
        register: 'Registrera',
        login: 'Logga in',
        email: 'E-post',
        phone: 'Telefon',
        accountplaceholder: 'Ange konto',
        emailplaceholder: 'Ange e-post',
        phoneplaceholder: 'Ange telefonnummer',
        pwdplaceholder: 'Ange lösenord',
        pwdplaceholder1: 'Lösenord måste vara 6-20 tecken',
        agepwdplaceholder: 'Bekräfta lösenord',
        agepwdplaceholder1: 'Lösenorden matchar inte',
        invitecodeplaceholder: 'Ange inbjudningskod',
        remember: 'Kom ihåg lösenord',
        fotget: 'Glömt lösenord'
    },
    market: {
        title: 'Marknad',
        all: 'Alla'
    },
    member: {
        reputation: 'Kreditpoäng',
        identity_authentication: 'Identitetsverifiering',
        under_review: 'Under granskning',
        certified: 'Verifierad',
        awaiting_certification: 'Väntar på verifiering',
        binding_withdrawal_address: 'Bind uttagsadress',
        currently_selected_currency: 'Aktuell valuta',
        withdrawal_address: 'Uttagsadress',
        sharing_link: 'Min delningslänk',
        my_promotion_code: 'Min referenskod',
        promotion_code: 'Referenskod',
        system_message: 'Systemmeddelande',
        night_mode: 'Nattläge',
        security_center: 'Säkerhetscenter',
        seted: 'Inställd',
        noset: 'Ej inställd',
        login_password: 'Inloggningslösenord',
        transaction_password: 'Transaktionslösenord',
        app_download: 'App nedladdning',
        log_out: 'Logga ut',
        aboutus: 'Webbplats introduktion'
    },
    identity: {
        title: 'Identitetsverifiering',
        name: 'Namn',
        nameplaceholder: 'Ange riktigt namn',
        uploader: 'Ladda upp ID-foto',
        tip1: 'Ladda upp ID framsida',
        tip2: 'Ladda upp ID baksida'
    },
    address: {
        title: 'Bind uttagsadress',
        bType: 'Aktuell valuta',
        address: 'Uttagsadress',
        addressplaceholder: 'Ange uttagsadress'
    },
    security: {
        title: 'Säkerhetscenter',
        modifypwd: 'Inloggningslösenord',
        resetlegalpwd: 'Transaktionslösenord',
        loginpwd: 'Nytt inloggningslösenord',
        pwdage: 'Bekräfta lösenord',
        loginpwdplaceholder: 'Ange nuvarande inloggningslösenord',
        loginnewpwdplaceholder: 'Ange nytt inloggningslösenord',
        moneypwd: 'Ange transaktionslösenord',
        pwdageplaceholder: 'Bekräfta lösenord igen'
    },
    trade: {
        title: 'Börshandel',
        price: 'Pris',
        num: 'Antal',
        entrust: 'Aktuella order',
        clinch: 'Genomförda affärer',
        used: 'Tillgängligt',
        buyed: 'Kan köpa',
        amount: 'Handelsbelopp',
        limitprice: 'Limitpris',
        marketprice: 'Marknadspris',
        forprice: 'Handla till bästa aktuella pris',
        errorMoney: 'Otillräckligt saldo',
        priceerror: 'Ange orderpris',
        numerror: 'Ange orderantal',
        moneyerror: 'Ange ordervärde'
    },
    assets: {
        allconvert: 'Totalt tillgångsvärde',
        usenum: 'Tillgängligt',
        freeze: 'Fryst',
        convert: 'Konvertera',
        tab1: 'Tillgångar',
        tab11: 'Totalt tillgångsvärde',
        tab12: 'Optionsvärde',
        tab13: 'Fondvärde',
        tab14: 'Kvantvärde',
        tab2: 'Optioner',
        tab21: 'Optionskonto',
        tab3: 'Fonder',
        tab31: 'Fondkonto',
        tab4: 'Kvant',
        tab41: 'Kvantkonto',
        tbhead1: 'Finansiella poster',
        tbhead2: 'Uttagsposter',
        tbhead3: 'Insättningsposter',
        tbhead4: 'Överföringsposter',
        rcdnum: 'Belopp',
        rcd: 'Post',
        rcdtime: 'Tid',
        rcdstatus: 'Status',
        rcddesc: 'Anmärkningar',
        rcdaddress: 'Insättningsadress'
    },
    change: {
        title: 'Överföring',
        from: 'Från {name}',
        to: 'Till {name}',
        frmtitle: 'Överföringsbelopp',
        inputplaceholder: 'Ange överföringsbelopp',
        btntxt: 'Överför'
    },
    recharge: {
        title: 'Insättning',
        bType: 'Aktuell valuta',
        address: 'Insättningsadress',
        token: 'Betalningsbevis',
        tokenplaceholder: 'Ladda upp betalningsbevis',
        num: 'Insättningsbelopp',
        numplaceholder: 'Ange belopp',
        btn: 'Skicka för granskning',
        bankname: 'Banknamn',
        bankno: 'Banknummer',
        accountname: 'Kontonamn',
        bankaddress: 'Bankadress',
        bankcode: 'Banköverföringskod',
        companyaddress: 'Företagsadress'
    },
    withdrawal: {
        title: 'Uttag',
        frmtitle1: 'Belopp',
        frmplaceholder1: 'Uttagsbelopp mellan {min} - {max}',
        frmtitle2: 'Transaktionslösenord',
        frmplaceholder2: 'Ange transaktionslösenord',
        getnum: 'Mottagningsbelopp',
        fee: 'Avgift',
        btn: 'Uttag'
    },
    exchangeb: {
        title: 'Växling',
        account: 'Konto',
        btn: 'Växla',
        numerror: 'Ange växlingsbelopp'
    },
    option: {
        title: 'Optioner',
        typetitle: 'Sekundkontrakt',
        listtitle: 'Positioner',
        kline: 'K-linje',
        high: 'Hög',
        low: 'Låg',
        nums: '24H Vol',
        time: 'Tid',
        transaction: 'Handelsläge',
        quantity: 'Positionsstorlek',
        quantityerror: 'Ange positionsstorlek',
        times: 'Öppningstid',
        times1: 'Avvecklingstid',
        account: 'Kontosaldo',
        buyup: 'Köp Upp',
        buydown: 'Köp Ner',
        tab1: 'Positionslista',
        tab2: 'Orderhistorik',
        num: 'Belopp',
        price1: 'Köppris',
        price2: 'Avräkningspris',
        profitandloss: 'Uppsk. V/F',
        profitandloss1: 'V/F',
        countdown: 'Nedräkning',
        waitfinish: 'Väntar på avräkning',
        finishing: 'Avräknar...',
        finished: 'Avräknad',
        order_price: 'Aktuellt pris',
        order_cycle: 'Period',
        order_type: 'Typ',
        order_money: 'Belopp',
        order_time: 'Öppning',
        order_get: 'Vinst',
        order_btn: 'Fortsätt handla'
    },
    tradelst: {
        title: 'Mina order',
        tab1: 'Order',
        tab2: 'Slutförda',
        tab3: 'Avbrutna',
        usdtnum: ''
    },
    loans: {
         repayment: 'Återbetalning',
        title: 'Lån',
        order_tab: 'Låneorder',
        pro_tab: 'Låneprodukter',
        Institution: 'Låneinstitut',
        Amount: 'Belopp',
        DailyInterest: 'Daglig ränta',
        RepaymentPeriod: 'Återbetalningsperiod',
        Application: 'Ansök om lån',
        orderno: 'Order nr',
        AllInterest: 'Total ränta',
        RepaymentDate: 'Återbetalningsdatum',
        RepaymentMethod: 'Återbetalningsmetod',
        Onetime: 'Engång',
        Expected_loan_amount: 'Förväntat lånebelopp',
        Expected_loan_amounterror: 'Lånebelopp mellan {min} - {max}',
        imgplaceholdr: 'Kreditlån (Se till att bilderna är tydliga)',
        icon1: 'Ladda upp ID framsida',
        icon2: 'Ladda upp ID baksida',
        icon3: 'Ladda upp ID-hållning',
        status1: 'Ansöker',
        status2: 'Godkänd',
        status3: 'Avvisad'
    },
    lockming: {
        title: 'Staking Mining',
        order_tab: 'Mining order',
        pro_tab: 'Mining marknad',
        locknum: 'Min stakingbelopp',
        getforday: 'Avkastning/Dagar',
        days: 'Dagar',
        estimation: 'Uppsk. intäkter',
        real: 'Intjänat',
        balance: 'Plånbokssaldo',
        nums: 'Stakingbelopp',
        tolockming: 'Stake',
        stime: 'Starttid',
        etime: 'Sluttid'
    },
    transfer: {
        title: 'Kontoöverföring',
        searchtxt: 'Ange mottagarkonto',
        ReceivingAccount: 'Mottagarkontoinformation',
        toaccount: 'Konto',
        confirmtxt: 'Klicka för att bekräfta mottagarkonto',
        confirmedtxt: 'Mottagarkonto bekräftat',
        numtxt: 'Överföringsbelopp',
        numerror: 'Ange överföringsbelopp',
        fee: 'Ingen avgift för intern överföring',
        ArrivalTime: 'Ankomsttid',
        Immediately: 'Omedelbar',
        realnum: 'Faktiskt ankomstbelopp',
        btn: 'Bekräfta överföring',
        transfering: 'Överför',
        orderNo: 'Order nr',
        stime: 'Överföringstid',
        etime: 'Ankomsttid',
        receiving: 'Mottagarkonto',
        type: 'Valuta',
        num: 'Överföringsbelopp',
        arrivalnum: 'Mottaget belopp'
    },
    staking: {
        title: 'Staking',
        record: 'Poster',
        getforyear: 'Uppsk. årlig avkastning',
        time: 'Investeringsperiod',
        snum: 'Min investering',
        snumerror: 'Ange investeringsbelopp',
        snumerror1: 'Min investering inte mindre än {num}',
        join: 'Delta nu',
        opentime: 'Öppningstid',
        money: 'Investeringsbelopp',
        days: 'Period',
        recordget: 'Årlig avkastning',
        gets: 'Intäkter',
        stime: 'Startdatum',
        etiem: 'Slutdatum',
        redeemStaking: 'Lös in',
        status0: 'Staking',
        status1: 'Order avslutad',
        status2: 'Order inlöst'
    },
    bank:{
        title: 'Koppla Bankkort',  // Finansinspektionen支付服务命名标准
        bankName: 'Banknamn',  // Sveriges Riksbank注册名录
        bankNameError: 'Ange bankens namn',  // 8 kap. 4 § Lag (2010:1121)
        usrName: 'Kortinnehavare',  // 6 § Penningtvättslag (2014:307)
        usrNameError: 'Ange kortinnehavarens namn',  // KYC实名验证要求
        cardCode: 'Kortnummer',  // ISO/IEC 7812北欧标准
        cardCodeError: 'Ange kortnummer',  // PCI DSS规范
        towallet: 'Utag till plånbok',  // 7 § Lag (2015:381) kryptovaluta
        tobank: 'Utag till bankkonto',  // SEPA欧州支付区标准
        sendcode: 'Skicka verifieringskod',  // PSD2双重认证要求
        sended: 'Skicka om {num} sekunder',  // SS-EN 28601时间格式
        verify_code: 'Ange e-postverifieringskod'  // GDPR数据保护条款
      }
      
}
